import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { cashdeskKeys } from './cashdeskKeys'
import { searchDirectory, type DirectoryRow } from './cashdeskApi'

/**
 * URL'dagi login → kassada ochiladigan abonent.
 *
 * <h2>⚠️ NATIJA UCH XIL «YO'Q» NI AJRATADI</h2>
 * Server «yo'q» deganda panel «bo'sh» deb chizmasligi kerak — bugungi
 * eng ko'p uchraydigan nuqson sinfi aynan shu. Shuning uchun holat
 * ochiq nomlangan:
 *
 *   · `failed`  — so'rovning O'ZI o'tmadi (403, 5xx, tarmoq). Sababi
 *     serverdan keladi va ekranda ko'rsatiladi.
 *   · `missing` — so'rov o'tdi, lekin bunday login qaytmadi: abonent
 *     yopilgan, o'chirilgan yoki boshqa tenantda.
 *   · `loading` — hali noma'lum; «topilmadi» deb yozish erta bo'lardi.
 *
 * <h2>⚠️ AYNAN TENG LOGIN</h2>
 * Katalog qidiruvi PREFIKS bo'yicha ishlaydi
 * (`SubscriberRepository.directorySearchSql`), ya'ni `ali` so'rovi
 * `ali1`, `ali2` ni ham qaytaradi. Birinchi qatorni olish BOSHQA
 * abonentni ochib yuborardi va keyingi bosish uning balansiga tegardi.
 *
 * ⚠️ Kesh kaliti `SubscriberSearch` bilan AYNI (`cashdeskKeys.search`):
 * pul amalidan keyin kesh bekor qilinganda bu ham yangilanadi, ya'ni
 * ekrandagi balans eskirib qolmaydi.
 */
export type PreselectState =
  | { kind: 'idle' }
  | { kind: 'loading'; login: string }
  | { kind: 'found'; login: string; row: DirectoryRow }
  | { kind: 'missing'; login: string }
  | { kind: 'failed'; login: string; error: unknown }

export function usePreselectedSubscriber(login: string | null): PreselectState {
  const wanted = login === null || login.trim() === '' ? null : login.trim()

  const query = useQuery({
    queryKey: cashdeskKeys.search(wanted ?? ''),
    queryFn: ({ signal }) => searchDirectory(wanted ?? '', signal),
    enabled: wanted !== null,
  })

  const { isError, isSuccess, error, data } = query

  // ⚠️ `useMemo` MAJBURIY: chaqiruvchi natijani effekt bog'liqligiga
  // qo'yadi va har chizishda yangi obyekt effektni cheksiz qaytarardi.
  return useMemo<PreselectState>(() => {
    if (wanted === null) return { kind: 'idle' }
    if (isError) return { kind: 'failed', login: wanted, error }
    if (!isSuccess) return { kind: 'loading', login: wanted }
    const row = (data ?? []).find((candidate) => candidate.login === wanted)
    return row === undefined
      ? { kind: 'missing', login: wanted }
      : { kind: 'found', login: wanted, row }
  }, [wanted, isError, isSuccess, error, data])
}
